<ng-container *ngIf="isLoginVisible">
  <th-app-notification></th-app-notification>

  <div class="card container col-md-6 col-lg-3">
    <div class="card-body">
      <form (ngSubmit)="form.valid && onSubmit(form)" autocomplete="off" #form="ngForm">
        <div class="form-group required">
          <label for="username">Username</label>
          <input
            [(ngModel)]="loginForm.username"
            type="text"
            class="form-control"
            name="username"
            id="username"
            #username="ngModel"
            required
          />
          <div *ngIf="form.submitted && username.invalid" class="invalid-feedback">
            <ng-container *ngIf="username.errors.required">Username is required</ng-container>
          </div>
        </div>

        <div class="form-group required">
          <label for="password">Password</label>
          <input
            [(ngModel)]="loginForm.password"
            type="password"
            class="form-control"
            name="password"
            id="password"
            #password="ngModel"
            required
          />
          <div *ngIf="form.submitted && password.invalid" class="invalid-feedback">
            <ng-container *ngIf="password.errors.required">Password is required</ng-container>
          </div>
        </div>
        <button type="submit" class="btn btn-primary btn-block" [thLoadingIndicator]="submitting">Log In</button>
        <!-- Link to patient registration is intentionally hidden for now -->
        <div class="text-center mt-2" *ngIf="false">
          Don't have an Account yet?
          <a routerLink="/register-new-patient" routerLinkActive="active">Create an account</a>
        </div>
        <div class="text-center mt-2">
          <a routerLink="/forgot-password" routerLinkActive="active">Forgot Password</a>
        </div>
      </form>
    </div>
  </div>
</ng-container>
